<template>
    <div class="get-hired">
      <div class="hired my-5 m-auto shadow-lg container-fluid">
        <div class="container">
          <div class="row p-5 get-hired-width">
            <div class="col-lg-5 text-left">
              <p class="font-weight-bolder hired-text-color text-uppercase">Are you an elite Developer?</p>
              <h4 class="hired-text-color very-bold text-capitalize font-italic">Get hired at top companies</h4>
            </div>
            <div class="col-lg-7 p-0">
              <router-link to="/devsignup">
                <button class="btn-kovatek ctrl-size rounded mt-3 mx-3 py-2 text-uppercase font-weight-bold" style="width: 150px">Dev sign up</button> 
              </router-link>
              <router-link to="/find-jobs">
                <button class="btn-kovatek ctrl-size rounded mt-3 mx-3 py-2 text-uppercase font-weight-bold" style="width: 150px">find jobs</button>          
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

export default {
    name: 'get-hired'
}

</script>
<style scoped>
.ctrl-size{
  font-size: 12px;
}
.hired{
  background-color: #C0E4D8;
}
.hired-text-color{
  color: #141D52;
}
.very-bold{
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
  font-size: 25px;
}
.very-bold1{
  font-weight: 900;
  text-shadow: 2px 0;
  letter-spacing: 2px;
  font-size: 36px;
}
.styled-btn{
  color:#fff;
  border-radius: 25px;
  outline: 0;
  transition: 0.2s;
}
.styled-btn:hover {
  box-shadow: 0 2px 4px rgba(0,0,0, 0.7);
}
.btn-dev-signup{
  background:linear-gradient(to right, rgb(75,179,142), rgb(28,71,152));
  border: 0;
  font-size: 10px;
  box-shadow: 0 0px 4px rgba(0,0,0, 0.3);
}
.btn-findjobs{
  background:linear-gradient(to right, rgb(254,151,22), rgb(241,100,45));
  border: 0;
  font-size: 10px;
  box-shadow: 0 0px 4px rgba(0,0,0, 0.3);
}
.get-hired-width{
  width: 80%;
  margin:auto;
}
@media screen and (max-width: 991px){
.get-hired-width{
  width: 100%;
  margin:auto;
}
}
@media screen and (max-width: 500px){

}
</style>
